import { render, staticRenderFns } from "./department-modal.vue?vue&type=template&id=cb32352c"
import script from "./department-modal.vue?vue&type=script&lang=js"
export * from "./department-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports